(function () {
  // ---------------------------------------------------------------------------
  // Delivery zones (works immediately, no backend needed).
  // Pickup is in Madhya Pradesh, so MP pincodes are fastest.
  // Edit the prefixes / day ranges below to match your real courier SLAs.
  //
  // To switch to LIVE Shiprocket data later: deploy the Cloudflare Worker,
  // set USE_LIVE_API = true, and put your Worker URL in WORKER_URL.
  // ---------------------------------------------------------------------------
  var USE_LIVE_API = false;
  var WORKER_URL = 'https://REPLACE_WITH_YOUR_WORKER_URL.workers.dev';

  var COD_AVAILABLE = true; // set false if you don't offer Cash on Delivery

  // Zones matched by the first 2 digits of the pincode.
  var ZONES = [
    { min: 2, max: 3, prefixes: ['45', '46', '47', '48'] }, // Madhya Pradesh
    {
      min: 3,
      max: 5,
      // Neighbouring states: UP/UK, Rajasthan, Gujarat, Maharashtra, Chhattisgarh
      prefixes: [
        '20', '21', '22', '23', '24', '25', '26', '27', '28',
        '30', '31', '32', '33', '34',
        '36', '37', '38', '39',
        '40', '41', '42', '43', '44',
        '49',
      ],
    },
  ];
  var DEFAULT_ZONE = { min: 5, max: 7 }; // rest of India

  function lookupZone(pincode) {
    var prefix = pincode.slice(0, 2);
    for (var i = 0; i < ZONES.length; i++) {
      if (ZONES[i].prefixes.indexOf(prefix) !== -1) {
        return ZONES[i];
      }
    }
    return DEFAULT_ZONE;
  }

  function daysLabel(min, max) {
    if (min === max) {
      return min + ' day' + (min === 1 ? '' : 's');
    }
    return min + '-' + max + ' days';
  }

  function initChecker(checker) {
    var input = checker.querySelector('.pincode-checker__input');
    var button = checker.querySelector('.pincode-checker__button');
    var result = checker.querySelector('.pincode-checker__result');

    function setResult(text, state) {
      result.textContent = text;
      result.className = 'pincode-checker__result';
      if (state) {
        result.classList.add('pincode-checker__result--' + state);
      }
    }

    function showEstimate(minDays, maxDays, codAvailable) {
      var codText = codAvailable ? 'Cash on Delivery available' : 'Prepaid orders only';
      setResult('Delivery in ' + daysLabel(minDays, maxDays) + ' · ' + codText, 'success');
    }

    function checkLocal(pincode) {
      var zone = lookupZone(pincode);
      showEstimate(zone.min, zone.max, COD_AVAILABLE);
    }

    function checkLive(pincode) {
      setResult('Checking...', null);
      button.disabled = true;
      fetch(WORKER_URL + '?pincode=' + encodeURIComponent(pincode))
        .then(function (res) { return res.json(); })
        .then(function (data) {
          button.disabled = false;
          if (data.error) {
            setResult('Could not check delivery right now. Please try again.', 'error');
          } else if (!data.serviceable) {
            setResult('Sorry, we currently do not deliver to this pincode.', 'error');
          } else {
            showEstimate(data.min_days, data.max_days, data.cod_available);
          }
        })
        .catch(function () {
          button.disabled = false;
          setResult('Could not check delivery right now. Please try again.', 'error');
        });
    }

    function check() {
      var pincode = (input.value || '').trim();
      if (!/^\d{6}$/.test(pincode)) {
        setResult('Please enter a valid 6-digit pincode.', 'error');
        return;
      }
      if (USE_LIVE_API) {
        checkLive(pincode);
      } else {
        checkLocal(pincode);
      }
    }

    button.addEventListener('click', check);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        check();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pincode-checker]').forEach(initChecker);
  });
})();
